import { render } from "./ClientsView.vue?vue&type=template&id=4c90f6ee&scoped=true"
import script from "./ClientsView.vue?vue&type=script&lang=js"
export * from "./ClientsView.vue?vue&type=script&lang=js"

import "./ClientsView.vue?vue&type=style&index=0&id=4c90f6ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c90f6ee"]])

export default __exports__